import React, { Component } from 'react'
import cx from 'classnames'

class WordlistShareBox extends Component {
  state = {
    copied: false,
  }

  render() {
    const { copied } = this.state
    return (
      <div className="bg-gray-50 text-sm px-2 pt-4 pb-2 my-4">
        <h4 className="mt0 mb-1">Dela</h4>
        <div className="flex items-stretch space-x-2">
          <div className='flex-1'>

            <input
                className="block pl-2 font-medium bg-white border text-pv-green-dark border-pv-green-dark w-full h-full"
                type="text"
                readOnly
                defaultValue={window.location.href}
                autoFocus
                onFocus={({ target }) => target.select()}
                ref={el => (this.inputElement = el)}
            />
          </div>
          <button
            className={cx(
              'flex-none self-stretch btn-white m0!',
              copied ? 'bg-green' : 'bg-green',
            )}
            type="button"
            onClick={() => {
              this.inputElement.select()
              document.execCommand('copy')
              this.setState({ copied: true })
            }}
          >
            {copied ? (
              <span>
                Kopierad <i className="fa fa-check" />
              </span>
            ) : (
              'Kopiera'
            )}
          </button>
        </div>
        <p className="">
          Kopiera webbadressen i fältet ovan och klistra in
          på valfritt ställe för att dela din lista med
          andra.
        </p>
      </div>
    )
  }
}

export default WordlistShareBox
